import React, { ReactElement } from 'react';

import { Label } from 'flowbite-react';

interface Props {
    readonly labelText: string;
    readonly children: ReactElement | Array<ReactElement>;
}

function ToolLabel({
    labelText,
    children,
}: Props) {
    return (
        <div className="flex flex-col gap-2 w-full sm:w-auto">
            <Label
                value={labelText}
                htmlFor={labelText}
            />
            <div className="flex gap-6 flex-wrap w-full sm:w-auto">{children}</div>
        </div>
    );
}

export default ToolLabel;
